import React, { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  en: {
    // header
    nav_home: "Home",
    nav_models: "Models",
    nav_how: "How it works",
    nav_leaderboard: "Leaderboard",
    nav_login: "Log in",
    nav_signup: "Join Program",
    nav_logout: "Logout",
    // hero
    hero_pill: "SSE Referral Program · 2026",
    hero_l1: "Refer an EV.",
    hero_l2: "Earn cash.",
    hero_l3: "Move India.",
    hero_sub: "Shri Shanteshwar Enterprises rewards customers, sales executives & influencers for every electric two-wheeler they help sell. Real cash. Straight to your bank.",
    hero_cta_primary: "Start Earning",
    hero_cta_secondary: "Explore Models",
    stat_paid: "Paid to referrers",
    stat_sold: "EVs sold via referrals",
    stat_cities: "Cities across India",
    rewards_title: "Cash Rewards",
    reward_customer: "Customer",
    reward_customer_perk: "per purchase",
    reward_sse: "SSE Staff",
    reward_sse_perk: "per conversion",
    reward_influencer: "Influencer",
    reward_influencer_perk: "per verified sale",
    // how
    how_kicker: "How it works",
    how_title_1: "Four moves.",
    how_title_2: "One payout.",
    how_sub: "Zero-effort onboarding. Full visibility on every lead. Cash lands in your account within 7 days of the referred customer taking delivery.",
    step_1_t: "Sign up",
    step_1_d: "Register as customer, SSE staff or influencer. Get your unique referral code instantly.",
    step_2_t: "Refer a buyer",
    step_2_d: "Share your link on WhatsApp or submit leads directly from your dashboard.",
    step_3_t: "We convert",
    step_3_d: "Our SSE team contacts, demos and closes. You track every stage live.",
    step_4_t: "Cash payout",
    step_4_d: "Add your bank / UPI. Request payout. Money in your account, no paperwork.",
    // models
    models_kicker: "Rosen E-Bikes · Price List",
    models_title_1: "Ride the Change.",
    models_title_2: "Go Electric.",
    models_sub: "Refer any of these models & earn cash rewards.",
    showroom: "Showroom",
    // card
    range: "Range",
    ex_showroom: "ex-showroom",
    price_on_request: "Price on request",
    save: "SAVE",
    battery: "Battery",
    monthly_emi: "Monthly EMI",
    per_month: "/mo",
    tenure: "Tenure",
    down_payment: "Down payment",
    months: "mo",
    emi_note: "Illustrative · 11% p.a. reducing",
    whatsapp_enquire: "WhatsApp Enquire",
    book_test_ride: "Book Test Ride",
    add_to_compare: "Compare",
    added_to_compare: "Added",
    compare_bar: "selected for comparison",
    compare_clear: "Clear",
    compare_view: "Compare now",
    compare_title: "Compare Models",
    compare_pick_more: "Pick 2 or 3 models to compare",
    tr_dialog_title: "Book a Test Ride",
    tr_dialog_sub: "We'll confirm your slot at our Basavakalyan showroom.",
    tr_name: "Your name",
    tr_phone: "Phone",
    tr_date: "Preferred date",
    tr_time: "Preferred time",
    tr_notes: "Notes (optional)",
    tr_submit: "Book test ride",
    tr_success: "Test ride booked! We'll call you soon.",
    lead_captured_toast: "Enquiry saved — you'll hear from us shortly.",
    // leaderboard
    lb_kicker: "Top Referrers",
    lb_title_1: "The",
    lb_title_2: "leaderboard",
    lb_sub: "Real referrers, real conversions, real payouts. Climb the board — the more EVs you help sell, the higher you rank.",
    lb_cta: "Get on the board",
    lb_empty: "Leaderboard is warming up. Be the first name on it.",
    lb_col_referrer: "Referrer",
    lb_col_role: "Role",
    lb_col_sales: "Sales",
    lb_col_earned: "Earned",
    // cta
    footer_cta_title: "Ready to refer & earn?",
    footer_cta_sub: "It takes 30 seconds to join. Your first payout could come this month.",
    footer_cta_btn: "Join the Program",
    footer_rights: "All rights reserved.",
    footer_care: "Customer Care",
  },
  kn: {
    nav_home: "ಮುಖಪುಟ",
    nav_models: "ಮಾಡೆಲ್‌ಗಳು",
    nav_how: "ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
    nav_leaderboard: "ಅಗ್ರಗಣ್ಯರು",
    nav_login: "ಲಾಗಿನ್",
    nav_signup: "ಸೇರಿ",
    nav_logout: "ಲಾಗ್ ಔಟ್",
    hero_pill: "SSE ರೆಫರಲ್ ಯೋಜನೆ · 2026",
    hero_l1: "ಇವಿ ಶಿಫಾರಸು ಮಾಡಿ.",
    hero_l2: "ನಗದು ಗಳಿಸಿ.",
    hero_l3: "ಭಾರತವನ್ನು ಚಲಿಸಿ.",
    hero_sub: "ಶ್ರೀ ಶಾಂತೇಶ್ವರ ಎಂಟರ್‌ಪ್ರೈಸಸ್ ಗ್ರಾಹಕರು, ಮಾರಾಟ ಪ್ರತಿನಿಧಿಗಳು ಮತ್ತು ಇನ್‌ಫ್ಲುಯೆನ್ಸರ್‌ಗಳಿಗೆ ಪ್ರತಿ ವಿದ್ಯುತ್ ದ್ವಿಚಕ್ರ ವಾಹನ ಮಾರಾಟಕ್ಕೆ ಬಹುಮಾನ ನೀಡುತ್ತದೆ. ನಿಜವಾದ ನಗದು. ನೇರವಾಗಿ ನಿಮ್ಮ ಬ್ಯಾಂಕ್‌ಗೆ.",
    hero_cta_primary: "ಗಳಿಸಲು ಆರಂಭಿಸಿ",
    hero_cta_secondary: "ಮಾಡೆಲ್‌ಗಳನ್ನು ನೋಡಿ",
    stat_paid: "ಪಾವತಿಸಲಾಗಿದೆ",
    stat_sold: "ಶಿಫಾರಸಿನಿಂದ ಮಾರಾಟ",
    stat_cities: "ನಗರಗಳಲ್ಲಿ ಸೇವೆ",
    rewards_title: "ನಗದು ಬಹುಮಾನಗಳು",
    reward_customer: "ಗ್ರಾಹಕ",
    reward_customer_perk: "ಪ್ರತಿ ಖರೀದಿಗೆ",
    reward_sse: "SSE ಸಿಬ್ಬಂದಿ",
    reward_sse_perk: "ಪ್ರತಿ ಮಾರಾಟಕ್ಕೆ",
    reward_influencer: "ಇನ್‌ಫ್ಲುಯೆನ್ಸರ್",
    reward_influencer_perk: "ಪರಿಶೀಲಿಸಿದ ಮಾರಾಟಕ್ಕೆ",
    how_kicker: "ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
    how_title_1: "ನಾಲ್ಕು ಹಂತ.",
    how_title_2: "ಒಂದೇ ಪಾವತಿ.",
    how_sub: "ಸುಲಭ ನೋಂದಣಿ. ಪ್ರತಿ ಗ್ರಾಹಕನನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ. ವಾಹನ ವಿತರಿಸಿದ 7 ದಿನಗಳಲ್ಲಿ ನಗದು ನಿಮ್ಮ ಖಾತೆಗೆ.",
    step_1_t: "ಸೈನ್ ಅಪ್",
    step_1_d: "ಗ್ರಾಹಕ, SSE ಸಿಬ್ಬಂದಿ ಅಥವಾ ಇನ್‌ಫ್ಲುಯೆನ್ಸರ್ ಆಗಿ ನೋಂದಾಯಿಸಿ. ತಕ್ಷಣ ವಿಶಿಷ್ಟ ರೆಫರಲ್ ಕೋಡ್ ಪಡೆಯಿರಿ.",
    step_2_t: "ಗ್ರಾಹಕರನ್ನು ಶಿಫಾರಸು ಮಾಡಿ",
    step_2_d: "ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ಲಿಂಕ್ ಹಂಚಿಕೊಳ್ಳಿ ಅಥವಾ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ನಿಂದ ನೇರವಾಗಿ ಸಲ್ಲಿಸಿ.",
    step_3_t: "ನಾವು ಮಾರುತ್ತೇವೆ",
    step_3_d: "ನಮ್ಮ SSE ತಂಡ ಸಂಪರ್ಕಿಸಿ, ಡೆಮೊ ನೀಡಿ, ಮಾರಾಟ ಪೂರ್ಣಗೊಳಿಸುತ್ತದೆ.",
    step_4_t: "ನಗದು ಪಾವತಿ",
    step_4_d: "ಬ್ಯಾಂಕ್ / UPI ಸೇರಿಸಿ. ಪಾವತಿ ವಿನಂತಿಸಿ. ಹಣ ನಿಮ್ಮ ಖಾತೆಗೆ.",
    models_kicker: "ರೋಸೆನ್ ಇ-ಬೈಕ್ · ಬೆಲೆ ಪಟ್ಟಿ",
    models_title_1: "ಬದಲಾವಣೆಗಾಗಿ ಸವಾರಿ ಮಾಡಿ.",
    models_title_2: "ವಿದ್ಯುತ್‌ಗೆ ಹೋಗಿ.",
    models_sub: "ಈ ಯಾವುದೇ ಮಾಡೆಲ್ ಶಿಫಾರಸು ಮಾಡಿ ನಗದು ಬಹುಮಾನ ಗಳಿಸಿ.",
    showroom: "ಶೋರೂಂ",
    range: "ರೇಂಜ್",
    ex_showroom: "ಎಕ್ಸ್-ಶೋರೂಂ",
    price_on_request: "ಬೆಲೆಗಾಗಿ ವಿಚಾರಿಸಿ",
    save: "ಉಳಿತಾಯ",
    battery: "ಬ್ಯಾಟರಿ",
    monthly_emi: "ಮಾಸಿಕ EMI",
    per_month: "/ತಿಂಗಳಿಗೆ",
    tenure: "ಅವಧಿ",
    down_payment: "ಡೌನ್ ಪೇಮೆಂಟ್",
    months: "ತಿಂಗಳು",
    emi_note: "ಸೂಚಕ · 11% ಪ್ರತಿ ವರ್ಷ",
    whatsapp_enquire: "ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ವಿಚಾರಿಸಿ",
    book_test_ride: "ಟೆಸ್ಟ್ ರೈಡ್ ಬುಕ್ ಮಾಡಿ",
    add_to_compare: "ಹೋಲಿಸಿ",
    added_to_compare: "ಸೇರಿಸಲಾಗಿದೆ",
    compare_bar: "ಹೋಲಿಕೆಗಾಗಿ ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ",
    compare_clear: "ಅಳಿಸಿ",
    compare_view: "ಈಗ ಹೋಲಿಸಿ",
    compare_title: "ಮಾಡೆಲ್‌ಗಳ ಹೋಲಿಕೆ",
    compare_pick_more: "ಹೋಲಿಸಲು 2 ಅಥವಾ 3 ಮಾಡೆಲ್‌ಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    tr_dialog_title: "ಟೆಸ್ಟ್ ರೈಡ್ ಬುಕ್ ಮಾಡಿ",
    tr_dialog_sub: "ಬಸವಕಲ್ಯಾಣ ಶೋರೂಂನಲ್ಲಿ ನಿಮ್ಮ ಸಮಯವನ್ನು ಖಚಿತಪಡಿಸುತ್ತೇವೆ.",
    tr_name: "ನಿಮ್ಮ ಹೆಸರು",
    tr_phone: "ಫೋನ್",
    tr_date: "ಆಯ್ಕೆ ದಿನಾಂಕ",
    tr_time: "ಸಮಯ",
    tr_notes: "ಟಿಪ್ಪಣಿ (ಐಚ್ಛಿಕ)",
    tr_submit: "ಬುಕ್ ಮಾಡಿ",
    tr_success: "ಟೆಸ್ಟ್ ರೈಡ್ ಬುಕ್ ಆಗಿದೆ! ಶೀಘ್ರವೇ ಕರೆ ಮಾಡುತ್ತೇವೆ.",
    lead_captured_toast: "ವಿಚಾರಣೆ ಉಳಿಸಲಾಗಿದೆ — ನಾವು ಶೀಘ್ರವೇ ಸಂಪರ್ಕಿಸುತ್ತೇವೆ.",
    lb_kicker: "ಅಗ್ರ ರೆಫರರ್‌ಗಳು",
    lb_title_1: " ",
    lb_title_2: "ಲೀಡರ್‌ಬೋರ್ಡ್",
    lb_sub: "ನಿಜವಾದ ರೆಫರರ್‌ಗಳು, ನಿಜವಾದ ಮಾರಾಟ, ನಿಜವಾದ ಪಾವತಿ. ಹೆಚ್ಚು ಮಾರಾಟ ಮಾಡಿದಷ್ಟೂ ಉನ್ನತ ಶ್ರೇಣಿ.",
    lb_cta: "ಪಟ್ಟಿಗೆ ಸೇರಿ",
    lb_empty: "ಲೀಡರ್‌ಬೋರ್ಡ್ ಇನ್ನಷ್ಟೇ ಪ್ರಾರಂಭಗೊಳ್ಳಬೇಕಿದೆ. ಮೊದಲಿಗರಾಗಿ.",
    lb_col_referrer: "ರೆಫರರ್",
    lb_col_role: "ಪಾತ್ರ",
    lb_col_sales: "ಮಾರಾಟ",
    lb_col_earned: "ಗಳಿಸಿದ್ದು",
    footer_cta_title: "ಶಿಫಾರಸು ಮಾಡಲು ಸಿದ್ಧರೇ?",
    footer_cta_sub: "ಸೇರಲು 30 ಸೆಕೆಂಡು ಸಾಕು. ಮೊದಲ ಪಾವತಿ ಈ ತಿಂಗಳೇ ಬರಬಹುದು.",
    footer_cta_btn: "ಯೋಜನೆಗೆ ಸೇರಿ",
    footer_rights: "ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
    footer_care: "ಗ್ರಾಹಕ ಸೇವೆ",
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sse_lang") || "en");
  useEffect(() => { localStorage.setItem("sse_lang", lang); }, [lang]);
  const t = (k) => DICT[lang]?.[k] ?? DICT.en[k] ?? k;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
